<template>
  <div>

    <div class="ps-shopping">
      <h3 class="ps-shopping__title">
        {{ $t('profile.orders.title') }}
      </h3>

      <div class="my-4">

        <table class="table table-bordered">
          <thead>
          <tr>
            <th>{{ $t('profile.orders.table.id') }}</th>
            <th>{{ $t('profile.orders.table.price') }}</th>
            <th>{{ $t('profile.orders.table.status') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="orders.length<1">
            <td colspan="4">
              <div class="alert alert-info">
                {{ $t('profile.orders.noOrders') }}
              </div>
            </td>
          </tr>
          <tr v-for="o in orders" :key="o.id">
            <td>
              <router-link :to="`/profile/order/${o.id}`">#{{ o.id }}</router-link>
            </td>
            <td>
              {{ o.price }} AZN
            </td>
            <td>
              <div class="badge bg-info text-white" v-if="o.orderStatus==='new'">
                 {{ $t('order.status.new') }}
              </div>
              <div class="badge bg-success text-white" v-else-if="o.orderStatus==='confirmed'">
                {{ $t('order.status.confirmed') }}
              </div>
              <div class="badge bg-warning"
                   v-else-if="o.orderStatus==='waiting_payment'">
                {{ $t('order.status.waiting_payment') }}
              </div>
              <div class="badge bg-success text-white" v-else-if="o.orderStatus==='paid'">
                {{ $t('order.status.paid') }}
              </div>
              <div class="badge bg-success text-white" v-else-if="o.orderStatus==='preparing'">
                {{ $t('order.status.prepearing') }}
              </div>
              <div class="badge bg-success text-white" v-else-if="o.orderStatus==='delivering'">
                {{ $t('order.status.delivering') }}
              </div>
              <div class="badge bg-success text-white" v-else-if="o.orderStatus==='finished'">
                {{ $t('order.status.finished') }}
              </div>
              <div class="badge bg-danger text-white" v-else-if="o.orderStatus==='cancelled'">
                {{ $t('order.status.canceled') }}
              </div>
              <div class="abadge bg-success text-white" v-else>
                {{ o.orderStatus }}
              </div>
            </td>
            <td>
              <router-link class="text-primary" :to="`/profile/order/${o.id}`">ətraflı</router-link>
            </td>
          </tr>

          </tbody>
        </table>

      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {baseUrl} from '../../repositories/Repository';
import {getOrders} from "../../repositories/UserRepository";

export default {
  layout: 'default',
  data() {
    return {
      baseDomain: baseUrl,
      orders: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      token: state => state.auth.token,
    }),
  },
  async created() {

    getOrders(this.token).then((orders) => {
      this.orders = orders;
    })

    this.$store.commit('app/setLoading', false);
  },
  methods: {}
}
</script>
